// src/i18n/index.ts
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { getInitialLanguage } from "./i18n.helper";
import resources from "./resources";
import type { LanguageType } from "./type";

i18n.use(initReactI18next).init({
  resources,
  lng: getInitialLanguage(),
  fallbackLng: "zh-CN",

  ns: [
    "admissionAssessmentTemplate",
    "appHeader",
    "blacklist",
    "common",
    "contractManagement",
    "deptSelectorModal",
    "evaluationTab",
    "home",
    "inquiryManagement",
    "language",
    "login",
    "menu",
    "materialExceptionLevel",
    "performanceAssessmentTemplate",
    "purchaseRequestManagement",
    "resetPassword",
    "safeWarning",
    "sourcingRequirementManagement",
    "supplierPerformance",
    "supplierVisitAndAudit",
    "supplierProfile",
    "systemSetting",
    "option",
    "supplierRiskLevel",
    "order",
  ],
  defaultNS: "common",

  interpolation: {
    escapeValue: false,
  },
});

export const getLanguage = (): LanguageType =>
  (i18n.language as LanguageType) || "zh-CN";

// 切换语言的函数
export const changeLanguage = (language: LanguageType): void => {
  i18n.changeLanguage(language);
  localStorage.setItem("language", language);
};

export default i18n;
